import { useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { useTranslation } from "react-i18next";
import useNotify from "hooks/useNotify";
import profileApi from "api/profile";
import { actions } from "store/actions";

function useExperience() {
  const dispatch = useDispatch();
  const [t] = useTranslation();
  const userDetails = useSelector((state) => state.userDetails || {});
  const [isLoading, setIsLoading] = useState(false);
  const [isEditExperience, setIsEditExperience] = useState(false);
  const { notifyError, notifySuccess } = useNotify();

  const vendorId = userDetails?.vendorId;
  const userId = userDetails?.id;

  const onSaveExperience = async (values) => {
    try {
      setIsLoading(true);
      const {
        domains,
        subDomains,
        customDomain,
        isWillingToTravel,
        isOpenForSecondment,
        yearOfExperience,
        catTools,
      } = values;

      const callback = (isSuccess, error) => {
        setIsLoading(false);

        if (isSuccess) {
          dispatch(actions.fetchUserDetails(userId));
          dispatch(actions.fetchUserDomains(userId));
          dispatch(actions.fetchUserSubDomains(userId));
          setIsEditExperience(false);
          notifySuccess("Has been updated successfully");
        } else {
          notifyError(error?.message || t("errorOccurred"));
        }
      };

      const canUpdateDomains = userDetails.flags.lockDomain
        ? {}
        : { domains, subDomains: subDomains, customDomain };

      dispatch(
        actions.updateVendorExperience(
          vendorId,
          {
            yearsOfExperience: Number.isNaN(Number(`${yearOfExperience}`))
              ? 0
              : Number(yearOfExperience),
            isWillingToTravel,
            isOpenForSecondment,
            catTools,
            ...canUpdateDomains,
          },
          callback
        )
      );
    } catch (error) {
      notifyError(error?.message || t("errorOccurred"));
    }
  };

  return {
    isLoading,
    isEditExperience,
    setIsEditExperience,
    onSaveExperience,
  };
}

export default useExperience;
